import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#000000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink
              target="_blank"
              href="https://www.zomato.com/vancouver/hamaei-japanese-restaurant-upper-lonsdale-north-vancouver"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Hamaei Sushi Zomato"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.yelp.ca/biz/hamaei-japanese-restaurant-north-vancouver">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Hamaei Sushi Yelp"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.facebook.com/HamaeiJapaneseRestaurant/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Hamaei Sushi Facebook"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.instagram.com/hamaeiwestview/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Hamaei Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#000000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink
              target="_blank"
              href="https://www.zomato.com/vancouver/hamaei-japanese-restaurant-upper-lonsdale-north-vancouver"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Hamaei Sushi Zomato"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.yelp.ca/biz/hamaei-japanese-restaurant-north-vancouver">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Hamaei Sushi Yelp"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.facebook.com/HamaeiJapaneseRestaurant/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Hamaei Sushi Facebook"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.instagram.com/hamaeiwestview/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Hamaei Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
